<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">Twiga court</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="/">Home <span class="sr-only">(current)</span></a>
      </li>
      <li v-if="isLoggedIn" class="nav-item">
         
            
            <a class="nav-link" href="/register/expense">New Expense </a>
            
         
          
            
          </li> 
       
          <li v-if="isLoggedIn" class="nav-item">
           
            
            <a class="nav-link" href="/all/payments">payments</a>
           
        
         
           
         </li>
         <li v-if="isLoggedIn" class="nav-item">
           
            
           <a class="nav-link" href="/mpesa/payments">Mpesa </a>
          
       
        
          
        </li>
         <li v-if="isLoggedIn" class="nav-item">
           
            
          <a class="nav-link" href="/create/member">Create member</a>
          
       
        
          
        </li>
          <li v-if="isLoggedIn" class="nav-item">
           
            
            
         
          
            
          </li>
          <li v-else class="nav-item dropdown">
            <a class="nav-link" href="/">Members</a>
            
          </li> 


     
     
    </ul>
   
  </div>
  <div v-if="isLoggedIn" class="dropdown">
    <a class="dropdown-item" href="#" @click="handleLogout">Logout</a>

</div>
</nav>
</template>
<style scoped>
.navbar .login-btn {
  position: absolute;
  top: 0px;
  right: 15px;
}
@media (max-width: 767px) {
  .navbar .login-btn {
    right: 75px;
  }
}
</style>

<script>
export default {
  data() {
    return {
      user: null,
      logoutTimer: null,
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },

  methods: {
    handleLogout() {
      this.$store.dispatch("clearToken");
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      if (this.logoutTimer) {
        clearInterval(this.logoutTimer);
        this.logoutTimer = null;
      }

      this.$router.push("/");
    },

    loadUserFromStorage() {
      const rawUser = localStorage.getItem("user");

      if (!rawUser) {
        this.user = null;
        return;
      }

      try {
        this.user = JSON.parse(rawUser);
      } catch (err) {
        console.error("Invalid user data in localStorage", err);
        localStorage.removeItem("user");
        this.user = null;
      }
    },
  },

  mounted() {
    this.loadUserFromStorage();

    // Auto logout ONLY if logged in
    if (this.isLoggedIn) {
      this.logoutTimer = setInterval(() => {
        this.handleLogout();
      }, 600000); // 10 minutes
    }
  },

  beforeUnmount() {
    if (this.logoutTimer) {
      clearInterval(this.logoutTimer);
    }
  },
};
</script>
